import { Directive, HostListener, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appDigitOnly]'
})
export class DigitOnlyDirective {
  constructor(private el: ElementRef<HTMLInputElement>) {
    this.el.nativeElement.type = 'tel';
    this.el.nativeElement.autocomplete = 'off';
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = [
      'Delete', 'Backspace', 'Tab', 'Escape', 'Enter',
      'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown',
      'Home', 'End', 'Left', 'Right',
      '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
      'Numpad0', 'Numpad1', 'Numpad2', 'Numpad3', 'Numpad4',
      'Numpad5', 'Numpad6', 'Numpad7', 'Numpad8', 'Numpad9',
      'F12'
    ];

    // 允許Cmd/Ctrl + 組合鍵(如Ctrl+C, Ctrl+V, Ctrl+X, Ctrl+A)
    if (allowedKeys.includes(event.key) ||
      (event.metaKey || event.ctrlKey) && ['a', 'c', 'x', 'v'].includes(event.key.toLowerCase())) {
      return;
    }

    const isDigit = event.key >= '0' && event.key <= '9';

    if (!isDigit) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();

    const input = this.el.nativeElement;
    const pastedText = event.clipboardData?.getData('text/plain') || '';
    let filteredText = pastedText.replace(/\D/g, '');

    const currentValue = input.value;
    const selectionStart = input.selectionStart ?? 0;
    const selectionEnd = input.selectionEnd ?? 0;

    // 使用paste輸入時，需要手動處理Input的maxlength屬性
    const maxLengthAttr = input.getAttribute('maxlength');

    if (maxLengthAttr) {
      const maxLength = parseInt(maxLengthAttr, 10);

      const currentLengthWithoutSelection = currentValue.length - (selectionEnd - selectionStart);

      const availableSpace = maxLength - currentLengthWithoutSelection;

      if (availableSpace > 0) {
        filteredText = filteredText.substring(0, availableSpace);
      } else {
        return;
      }
    }

    const newValue =
      currentValue.substring(0, selectionStart) +
      filteredText +
      currentValue.substring(selectionEnd);

    input.value = newValue;

    const newCursorPosition = selectionStart + filteredText.length;

    input.selectionStart = newCursorPosition;
    input.selectionEnd = newCursorPosition;

    // 觸發'input'事件，通知Angular Form Module或其他綁定機制值已更改
    // 這是關鍵，以確保Angular的Form Controls(如 NgModel)能感知到這個變化。
    const inputEvent = new Event('input', { bubbles: true });
    input.dispatchEvent(inputEvent);
  }
}
